import { inject } from "@angular/core"
import { ActivatedRoute } from "@angular/router"
import { Observable, map } from "rxjs"

export function getAuthRedirectUrl(): string {
    return inject(ActivatedRoute).snapshot.queryParams['redirect'];
}